import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_GDPR_USER_LIST } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import GdprUsersList from '../../components/GdprUsersList';

export const Route = createFileRoute('/_authenticated/gdpr-user/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_GDPR_USER_LIST, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: { main: 'menu.gdprUsersList', suffix: 'menu.gdpr' },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: GdprUserRoute,
});

function GdprUserRoute() {
  return <GdprUsersList />;
}
